const roles = [
    {
        id: 'agep-enseignant',
        title: 'Enseignant'
    },
    {
        id: 'agep-intervenant',
        title: 'Formateur'
    },
    {
        id: 'agep-direction',
        title: 'Directeur'
    },
    {
        id: 'agep-dip',
        title: 'DIP'
    },
    {
        id: 'agep-autre',
        title: 'Autre'
    },
];

export default roles;


// WEBPACK FOOTER //
// ./src/features/Auth/userRoles.js